export default {
  boxTypes({ boxTypes }) {
    return boxTypes;
  },
  editing({ editing }) {
    return editing;
  },
};
